<template>

<div>

    <div v-if='!offerSent'>
        <h3 class="fieldset-title">Заяви участие в този търг</h3>

        
        
        <div class="row">
            <div class="col-12 col-md-6 mt-2">
                <div class="form-group">
                    <h6 class="mb-0"><label for="time-period">Срок на изпълнение:</label></h6>
                    <input class="form-control" type="number" v-model='model.time' id="time-period" placeholder="Брой дни">
                </div>
            </div>
        
            <div class="col-12 col-md-6 mt-2">
                <div class="form-group">
                    <h6 class="mb-0"><label for="price-work">Възнаграждение, което желаете:</label></h6>
                    <input class="form-control" type="number" v-model='model.cost' id="price-work" placeholder="Сума в лева">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">

                <div class="alert alert-info">
                    <div>
                        <small class="mb-2">
                            Имайте предвид, че дължите такса на ВИДЕА. Тя се определя като <strong>{{ this.$store.state.coefs.tp }}%</strong> от вашата оферта, но не по-малко от <strong>{{ this.$store.state.coefs.mt }}лв.</strong>
                        </small>
                        <p class="mb-0">
                            Такса за Видеа: {{ videaTax }} лв., <br/>
                            Оставаща сума за вас: {{ getSumLeft() }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <phase-terms :desc='$parent.$parent.phase.desc'></phase-terms>

        <div class="row">
            <div class="col-12 text-center mt-2">
                <button @click='sendOffer' class="btn btn-primary btn-lg">Изпрати предложението</button>
            </div>
        </div>
    </div>

    <div v-if='offerSent'>
        <h3 class="fieldset-title">
            Вие участвате в тази фаза на проекта.
        </h3>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                isReady     : false,
                acceptTerms : false,
                offerSent   : false,

                model : {
                    time : null,
                    cost : null,
                }
            }
        },

        methods : {

            getSumLeft() {
                var sum = this.model.cost - this.videaTax;
                
                if( sum < 0 ) {
                    return 'Моля въведете възнаграждение по-голямо от таксата на Видеа.';
                }

                return sum + ' лв.';
            },

            sendOffer() {

                if( !this.model.time ) {
                    $.notify('Моля въведете срок за изпълнението','warning');
                    $("#time-period").focus();

                    return;
                }

                if( !this.model.cost ) {
                    $.notify('Моля въведете цена за изпълнението','warning');
                    $("#price-work").focus();

                    return;
                }

                if( this.model.cost < this.videaTax ) {
                    $.notify('Моля въведете цена по-голяма от таксата на Видеа','warning');
                    $("#price-work").focus();

                    return;
                }

                if( !this.acceptTerms ) {
                    $.notify('Моля приемете изискванията за да кандидатствате','warning');

                    return;
                }

                var me = this;

                //Apply for work
                me.ajax.call('phs:suo', { o : this.model, pp : this.$parent.$parent.projectPhase.id }, (r) => {
                    
                    if( r.status == 'success' ) {
                        me.offerSent = true;

                        $.notify('Успешно заявихте участието си в този етап на проекта!','success');
                    } 

                })

            }

        },

        computed : {

            videaTax() {
                var min = this.$store.state.coefs.mt;
                var per = Math.ceil( this.model.cost * this.$store.state.coefs.tp / 100 );
                
                if( min > per ) {
                    return min;
                } else {
                    return per;
                }
            }

        }

    }
</script>
